const standardColors = [
    'var(--spinner-light-color)',
    'var(--spinner-dark-color)',
    'var(--spinner-pastel-color)',
    'var(--spinner-medium-color)',
];

const constitutionDayColors = [
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#FFFFFF',
    '#00205b',
    '#00205b',
    '#FFFFFF',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#BA0C2F',
    '#FFFFFF',
    '#00205b',
    '#00205b',
    '#FFFFFF',
];

const prideColors = ['#ED3333', '#FFA533', '#FFF133', '#349A4E', '#3370FF', '#9233A0'];

export const getType = () =>
    Array.from(document.documentElement.classList)
        .find((className) => className.startsWith('sgw-loader--'))
        ?.replace('sgw-loader--', '');

export const getColors = () => {
    switch (getType()) {
        case 'pride':
            return prideColors;
        case 'constitution-day':
            return constitutionDayColors;
        default:
            return standardColors;
    }
};
